export default __webpack_public_path__ + "static/media/resting-icon.818975e6.svg";